/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { Col, Select, Button, Form, Row, message, notification } from "antd";
import urls from "../../../api/urls";
import API from "../../../api";
import {
  getUserAndPremiseId,
  capitaliseWithHyphen,
  getCurretRole,
} from "../../../utils";
import { getToken, getPremiseId } from "../../../utils/worker";
import delete_icon from "../../../assests/images/deleteRed.svg";

import axios from "axios";
const FileUpload = ({ setLoading, hitListApi, pendingPresent, clientList }) => {
  const imgLogoRef = useRef(null);
  const [form] = Form.useForm();

  const [department, setDepartment] = useState([]);
  const [clientId, setClientID] = useState(null);
  const [fileName, setFileName] = useState();
  const [fileInfo, setfileInfo] = useState([]);
  const [fileBlobUrl, setFileBlobUrl] = useState("");
  const currentEnv = process.env.REACT_APP_ENV;
  const { GET_CLIENT_LIST_NEW, GET_CLIENT_INNO, POST_BULK_BOOK } = urls;
  const getUserInfo = getUserAndPremiseId();
  const userId = getUserInfo?.userId;
  const token = getToken();
  const premiseId = getPremiseId();
  const isClientAdmin = getCurretRole();

  const acceptedFile = ["xlsx", "xls"];

  const getDepartMentQA = async (selectedClient, selectedDepartment) => {
    form.setFieldsValue({
      department: null,
    });

    const currentDepartment = selectedDepartment
      ? [selectedDepartment?.item]
      : selectedClient?.department || [];

    if (selectedClient) {
      setDepartment(
        selectedClient?.department?.map((item, i) => ({
          key: i,
          value: i,
          label: getDepartmentContactName(item),
          item: item,
        }))
      );
    }
    const item = currentDepartment[0];
    const mergeName = getDepartmentContactName(item);

    form.setFieldsValue({
      department: mergeName,
    });
    setClientID(item?.ClientID);
  };
  const getDepartmentContactName = (item) => {
    let departmentName =
      item?.Department && item?.Department !== ""
        ? item?.Department
        : "Default";

    let contactName =
      item?.ContactPerson && item?.ContactPerson !== ""
        ? "-" + item?.ContactPerson
        : "";

    if (contactName !== "" && departmentName === "Default") {
      departmentName = "";
      contactName =
        item?.ContactPerson && item?.ContactPerson !== ""
          ? item?.ContactPerson
          : "";
    }

    return departmentName + contactName;
  };
  const setClientDepartment = async (selectedClient, selectedDepartment) => {
    form.setFieldsValue({
      department: null,
    });

    const currentDepartment = selectedDepartment
      ? [selectedDepartment?.item]
      : selectedClient?.department || [];

    if (selectedClient) {
      setDepartment(
        selectedClient?.department?.map((item, i) => ({
          key: i,
          value: i,
          label: getDepartmentContactName(item),
          item: item,
        }))
      );
    }
    const item = currentDepartment[0];
    const mergeName = getDepartmentContactName(item);

    form.setFieldsValue({
      department: mergeName,
    });
    setClientID(item?.ClientID);
  };

  ///---File Upload---///
  const logoUpload = () => {
    imgLogoRef.current.click();
  };

  const onChangeLogo = (e) => {
    try {
      if (e?.target || e?.dataTransfer) {
        e.preventDefault();
        let files;
        if (e?.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        let x = files[0].name.split(".");
        let y = x[x.length - 1];

        if (files[0].size > 5000000) {
          message.warning("Maximum upload size is 5 MB.", [3]);
        } else if (acceptedFile.includes(y)) {
          const reader = new FileReader();
          reader.onload = () => {};
          setFileName(e.target.files[0].name);
          const blobUrl = URL.createObjectURL(e.target.files[0]);
          setFileBlobUrl(blobUrl);
          setfileInfo(e.target.files[0]);
          // message.success("Added Successfully");
          reader.readAsDataURL(files[0]);
        } else {
          return message.warning("Only xlsx files are allowed.", [3]);
        }
      }
    } catch (error) {
      //need for error handling
      console.log(error);
    }
  };

  function removeFile() {
    document.getElementById("uploadFile").value = "";
    // message.success("File removed successfully");
    setFileBlobUrl("");
    setFileName("");
    setfileInfo([]);
  }
  const UploadFile = () => {
    setLoading(true);
    let formData = new FormData();
    formData.append("file", fileInfo);

    let webToken = token.slice(6);
    const company_id =
      JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;

    const sevasetuIds = JSON.parse(localStorage.getItem("userinfo")) || null;
    let bulkBookingHeader = {};

    bulkBookingHeader = {
      client_id: isClientAdmin ? sevasetuIds?.sevasetuClientId : clientId,
    };

    const headers = {
      "USER-ID": userId,
      Authorization: token,
      token: webToken,

      ...bulkBookingHeader,
    };

    axios
      .post(POST_BULK_BOOK, formData, {
        headers,
      })
      .then((response) => {
        message.success(response?.data || "Data Saved successfully");
        setLoading(false);
        hitListApi();
        removeFile();
      })
      .catch((error) => {
        setLoading(false);
        const fileDetails = error?.response?.data?.fileDetails;
        if (fileDetails) {
          if (fileDetails) {
            const base64File = fileDetails;
            const fileName = "error_file.xlsx";

            const byteCharacters = atob(base64File);
            const byteNumbers = new Array(byteCharacters.length)
              .fill(0)
              .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = URL.createObjectURL(blob);

            notification.error({
              message: "Uploaded file have some errors.",
              duration: 8,
              description: (
                <a
                  href={url}
                  download={fileName}
                  onClick={() => {
                    setTimeout(() => {
                      URL.revokeObjectURL(url);
                    }, 5000);
                  }}
                >
                  Click here to Download the file
                </a>
              ),
            });
          }
        } else {
          notification.error({
            message: error?.response?.data?.message || "Internal server error",
            description: "",
          });
        }
      });
  };

  ///---///
  return (
    <Form form={form} className="global-form" layout="vertical">
      <Row className="global-form-row" gutter={16}>
        {!isClientAdmin ? (
          <Col span={7}>
            <Form.Item
              name="clientName"
              label="Client"
              rules={[
                {
                  required: true,
                  message: "Select client",
                },
              ]}
            >
              <Select
                placeholder="Select client"
                showSearch
                onSelect={(value, obj) => {
                  if (currentEnv == "qa") {
                    getDepartMentQA(obj);
                  } else {
                    setClientDepartment(obj);
                  }
                }}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                defaultActiveFirstOption
                options={clientList}
              ></Select>
            </Form.Item>
          </Col>
        ) : null}
        {!isClientAdmin ? (
          <Col span={7}>
            <Form.Item
              name="department"
              label="Department"
              rules={[
                {
                  required: true,
                  message: "Select department",
                  validateTrigger: "onSubmit",
                },
              ]}
            >
              <Select
                showAction={["focus", "click"]}
                placeholder="Select department"
                options={department}
                onSelect={(value, obj) => {
                  setClientDepartment(null, obj);
                }}
              ></Select>
            </Form.Item>
          </Col>
        ) : null}

        <Col className="upload-btn mt-2" span={9}>
          {fileInfo.length === 0 && (
            <Button
              type="primary"
              onClick={logoUpload}
              className={!clientId || pendingPresent ? "btn-style" : "save-btn"}
              disabled={isClientAdmin ? false : !clientId || pendingPresent}
            >
              <span className="capitalize">Upload File</span>
            </Button>
          )}
          <input
            type="file"
            onChange={onChangeLogo}
            hidden
            ref={imgLogoRef}
            accept={acceptedFile}
            id={"uploadFile"}
          />

          <Row align="baseline" className="file-name">
            {/* {overflowFunc(fileName, 300)} */}
            <span>{fileName}</span>
            {/* <a
              href={fileBlobUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginRight: "8px" }}
            >
              {fileName}
            </a> */}

            {fileName?.length ? (
              <img
                src={delete_icon}
                onClick={removeFile}
                height={20}
                width={20}
                className="ml-1 pointer"
              />
            ) : null}
            {fileInfo.length != 0 && (
              <Button
                className={"ml-1-5 save-btn"}
                type="primary"
                onClick={UploadFile}
              >
                {"SUBMIT"}
              </Button>
            )}
          </Row>
          {/* <div id="fileLinkContainer"></div> */}
        </Col>

        {/* <Col span={3} className="mt-2">
          <a
            href={sampleUrl}
            //download="SamplePacketingGuide.xlsx"
          >
            {" "}
            Download template
          </a>
        </Col> */}
      </Row>
    </Form>
  );
};
export default FileUpload;
